import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
// import { renewContract } from '../../../api'
import { KTSVG } from '../../../_metronic/helpers'

function RenewContractModal({
  isOpen,
  onClose,
  onSuccess,           // ← add
  enterpriseId,
  enterpriseName,
  currentContractEndDate,    // ← new prop
}) {
  const [formData, setFormData] = useState({
    new_contract_start_date: '',
    new_contract_duration_months: '',
  })
  const [loading, setLoading] = useState(false)

  // Pre-fill start date with current contract end date when modal opens
  useEffect(() => {
    if (isOpen) {
      // Raw date from API is already in YYYY-MM-DD format — no parsing needed
      setFormData({
        new_contract_start_date: currentContractEndDate || '',
        new_contract_duration_months: '12',   // ← default 12 months
      })
    }
  }, [isOpen, currentContractEndDate])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  // const validateForm = () => {
  //   if (!formData.new_contract_start_date) return 'Contract Start Date is required.'
  //   if (!formData.new_contract_duration_months || Number(formData.new_contract_duration_months) < 1)
  //     return 'Duration must be at least 1 month.'
  //   return null
  // }

  const handleSubmit = async () => {
    // const error = validateForm()
    // if (error) { Swal.fire({ icon: 'error', title: error }); return }
    // setLoading(true)
    // try {
    //   await renewContract({
    //     enterprise_id: enterpriseId,
    //     new_contract_start_date: formData.new_contract_start_date,
    //     new_contract_duration_months: Number(formData.new_contract_duration_months),
    //   })
    //   Swal.fire({ icon: 'success', title: `Contract renewed for ${enterpriseName}` }).then(() => {
    //     handleClose()
    //     onSuccess?.()      // ← add
    //   })
    // } catch (error: any) {
    //   Swal.fire({ icon: 'error', title: error.response?.data?.detail || 'Failed to renew contract.' })
    // } finally {
    //   setLoading(false)
    // }
  }

  const handleClose = () => {
    setFormData({ new_contract_start_date: '', new_contract_duration_months: '' })
    onClose()
  }

  return (
    <div className={`modal fade ${isOpen ? 'show' : ''}`} tabIndex={-1} style={{ display: isOpen ? 'block' : 'none' }}>
      <div className='modal-dialog' style={{ marginTop: '9rem' }}>
        <div className='modal-content'>
          <div className='modal-header'>
            <h3 className='modal-title'>Renew Contract — {enterpriseName}</h3>
            <div className='btn btn-icon btn-sm btn-active-secondary ms-2' onClick={handleClose}>
              <KTSVG path='media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
            </div>
          </div>
          <div className='modal-body'>
            {/* Info banner */}
            <div className='alert alert-info mb-4' style={{ fontSize: '13px' }}>
              Renewal starts from the current contract end date. Adjust if needed.
            </div>
            <div className='mb-3'>
              <label className='form-label required'>New Contract Start Date</label>
              <input
                type='date'
                name='new_contract_start_date'
                className='form-control form-control-solid'
                value={formData.new_contract_start_date}
                onChange={handleInputChange}
              />
            </div>
            <div className='mb-3'>
              <label className='form-label required'>New Duration (months)</label>
              <input
                type='number'
                name='new_contract_duration_months'
                className='form-control form-control-solid'
                placeholder='e.g. 12'
                value={formData.new_contract_duration_months}
                onChange={handleInputChange}
                min={1}
              />
            </div>
          </div>
          <div className='modal-footer'>
            <button className='btn btn-secondary' onClick={handleClose}>Cancel</button>
            <button className='btn' style={{ backgroundColor: '#6D9300', color: 'white' }} onClick={handleSubmit} disabled={loading}>
              {loading ? 'Saving...' : 'Renew Contract'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RenewContractModal